<template>
  <div class="guaranteed-bad-record-new">
    <Row :gutter="16">
      <i-col span="20">
        <Form ref="newForm" :model="companyModel"
          :rules="modelValidate"
          label-position="left"
          :label-width="220">
          <FormItem label="投保人名称" prop="GuaranteedName">
            <Input v-model="companyModel.GuaranteedName" placeholder="输入投保人名称" />
            <!-- <Select
              v-model="companyModel.GuaranteedName"
              filterable
              remote
              clearable
              @on-select="selectCompany"
              @on-clear="clearCompany"
              placeholder="输入投保人名称"
              :remote-method="searchCompany"
              :loading="loading">
              <Option v-for="(option, index) in companies" :value="option.name" :tag="option.tid" :key="index">{{option.name}}</Option>
            </Select> -->
          </FormItem>
          <FormItem label="投保人统一社会信用代码证号" prop="GuaranteedBusinessLicense">
            <Input v-model="companyModel.GuaranteedBusinessLicense" placeholder="输入投保人统一社会信用代码证号" />
          </FormItem>
          <FormItem label="代偿项目名称" prop="ProjectName">
            <Input v-model="companyModel.ProjectName" placeholder="输入代偿项目名称" />
            <!-- <Select
              v-model="companyModel.ProjectName"
              filterable
              remote
              clearable
              @on-select="selectGuarantee"
              @on-clear="clearGuarantee"
              placeholder="输入代偿项目名称"
              :remote-method="searchGuarantees"
              :loading="loading">
              <Option v-for="(option, index) in guarantees" :value="option.prjName" :tag="option.id" :key="index">{{option.prjName}}</Option>
            </Select> -->
          </FormItem>
          <FormItem label="项目经理姓名" prop="PrjManagerName">
            <Input v-model="companyModel.PrjManagerName" placeholder="输入项目经理姓名" />
          </FormItem>
          <FormItem label="项目经理注册建造师编号" prop="PrjManagerConstructorNo">
            <Input v-model="companyModel.PrjManagerConstructorNo" placeholder="输入项目经理注册建造师编号" />
          </FormItem>
          <FormItem label="项目所在地" prop="PrjCityId">
            <Cascader v-model="companyModel.cities" :data="cities" :load-data="loadCityData" @on-change="citySelected" placeholder="选择"></Cascader>
          </FormItem>
          <FormItem label="担保品种" prop="GuaType">
            <Select v-model="companyModel.GuaType" filterable>
              <Option v-for="(tp,idx) in guaTypes" :key="idx" :value="parseInt(tp.id)">{{tp.fullName}}</Option>
            </Select>
          </FormItem>
          <FormItem label="担保金额(元)" prop="GuaAmount">
            <InputNumber :min="0" :step="1000"
              style="width: 150px;display:inline-block"
              v-model="companyModel.GuaAmount"
              placeholder="输入担保金额(元)"></InputNumber>
            <Divider type="vertical" v-if="companyModel.GuaAmount" />
            <h3 style="display:inline-block" v-if="companyModel.GuaAmount"> {{`¥ ${companyModel.GuaAmount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</h3>
            <Divider type="vertical" v-if="companyModel.GuaAmount" />
            <h3 style="display:inline-block">{{$common.transformNumberIntoCHS(companyModel.GuaAmount)}}</h3>
          </FormItem>
          <FormItem label="代偿时间" prop="CompensationDate">
            <Date-picker type="date" v-model="companyModel.CompensationDate" placeholder="YYYY-MM-DD" style="width: 150px"></Date-picker>
          </FormItem>
          <FormItem label="代偿金额(元)" prop="CompensationAmount">
            <InputNumber :min="0" :step="1000"
              style="width: 150px;display:inline-block"
              v-model="companyModel.CompensationAmount"
              placeholder="输入代偿金额(元)"></InputNumber>
            <Divider type="vertical" v-if="companyModel.CompensationAmount" />
            <h3 style="display:inline-block" v-if="companyModel.CompensationAmount"> {{`¥ ${companyModel.CompensationAmount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</h3>
            <Divider type="vertical" v-if="companyModel.CompensationAmount" />
            <h3 style="display:inline-block">{{$common.transformNumberIntoCHS(companyModel.CompensationAmount)}}</h3>
          </FormItem>
          <FormItem label="约定还款时间" prop="AgreedPayDate">
            <Date-picker type="date" v-model="companyModel.AgreedPayDate" placeholder="YYYY-MM-DD" style="width: 150px"></Date-picker>
          </FormItem>
          <FormItem label="约定时间内尚未还清金额(元)" prop="AgreedPayAmount">
            <InputNumber :min="0" :step="1000"
              style="width: 150px;display:inline-block"
              v-model="companyModel.AgreedPayAmount"
              placeholder="输入约定时间内尚未还清金额(元)"></InputNumber>
            <Divider type="vertical" v-if="companyModel.AgreedPayAmount" />
            <h3 style="display:inline-block" v-if="companyModel.AgreedPayAmount"> {{`¥ ${companyModel.AgreedPayAmount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</h3>
            <Divider type="vertical" v-if="companyModel.AgreedPayAmount" />
            <h3 style="display:inline-block">{{$common.transformNumberIntoCHS(companyModel.AgreedPayAmount)}}</h3>
          </FormItem>
          <FormItem label="在双方约定期限内是否还清" prop="IsPaidOff">
            <i-switch v-model="companyModel.IsPaidOff" size="large">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </FormItem>
          <FormItem>
            <Button type="primary" size="large" long @click="submit">保存</Button>
          </FormItem>
        </Form>
      </i-col>
      <i-col span="8">
      </i-col>
    </Row>
  </div>
</template>

<script>
export default {
  name: 'guaranteed-bad-record-new',
  props: {
  },
  data () {
    return {
      loading: false,
      guarantees: [],
      projects: [],
      companies: [],
      cities: [],
      guaTypes: [],
      companyModel: {
        GuaranteedName: null,
        GuaranteedBusinessLicense: null,
        ProjectName: null,
        PrjManagerName: null,
        PrjManagerConstructorNo: null,
        PrjCityId: null,
        GuaType: null,
        GuaAmount: null,
        CompensationDate: null,
        CompensationAmount: null,
        AgreedPayDate: null,
        AgreedPayAmount: 0,
        IsPaidOff: false,
        cities: [],
      },
      modelValidate: {
        PrjCityId: [
          { required: true, type: 'number', message: '请选择项目所在地', trigger: 'blur' }
        ],
        GuaType: [
          { required: true, type: 'number', message: '请选择类型', trigger: 'blur' }
        ],
        GuaranteedName: [
          { required: true, message: '请填写投保人名称', trigger: 'blur' }
        ],
        GuaranteedBusinessLicense: [
          { required: true, message: '请填写投保人社会信用代码', trigger: 'blur' }
        ],
        ProjectName: [
          { required: true, message: '请填写代偿项目名称', trigger: 'blur' }
        ],
        GuaAmount: [
          { required: true, type: 'number', message: '请填写担保金额', trigger: 'blur' }
        ],
        CompensationAmount: [
          { required: true, type: 'number', message: '请填写代偿金额', trigger: 'blur' }
        ],
        CompensationDate: [
          { required: true, type: 'date', message: '请填写发布日期', trigger: 'change' },
        ],
        AgreedPayDate: [
          { required: true, type: 'date', message: '请填写约定还款日期', trigger: 'change' },
        ],
        AgreedPayAmount: [
          { required: true, type: 'number', message: '请填写约定时间内尚未还清金额', trigger: 'blur' }
        ],
      },
    }
  },
  watch: {
  },
  mounted () {
    this.initCitySelect()
    this.initGuaTypes()
    this.companyModel.CompensationDate = new Date()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    async initGuaTypes () {
      return new Promise((resolve, reject) => {
        this.$Spin.show()
        this.$Api.Guarantee.getGuaranteeVarieties().then(res => {
          let result
          if (window.localStorage.getItem('view-mode') === 'migrantworker-only') {
            result = res.filter((tp) => {
              return tp.fullName === '建筑务工人员工资支付保证金担保'
            })
            this.companyModel.GuaType = result[0].id
          } else {
            result = res
          }
          this.guaTypes = result
          this.$Spin.hide()
          resolve(result)
        }).catch(err => {
          this.$Message.error(err.message)
          this.$Spin.hide()
          reject(err)
        })
      })
    },
    initCitySelect () {
      this.$Api.City.listCities({
        tier: 1,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          return {
            id: c.tid,
            value: c.tid,
            label: c.name,
            tier: c.tier,
            parent: c.parent,
            loading: false,
            children: []
          }
        })
        this.cities = data
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
      })
    },
    loadCityData (item, callback) {
      item.loading = true
      let parentId = item.value
      let tier = item.tier || 0
      let curNode = null
      if (tier === 1) {
        curNode = this.cities.filter((c) => {
          return c.id === item.id
        })[0]
      } else {
        let parentNode = this.cities.filter((c) => {
          return c.id === item.parent
        })
        curNode = parentNode[0]
      }
      console.log(curNode)
      this.$Api.City.listCities({
        tier: tier + 1,
        parentId: parentId,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = []
        cities.data.forEach((c) => {
          if (tier === 1) {
            // 地市
            data.push({
              id: c.tid,
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent,
              loading: false,
              children: []
            })
          } else {
            data.push({
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent
            })
          }
        })
        let retData = []
        if (tier > 1) {
          retData.push({
            value: parentId,
            label: '本级'
          })
        } else if (tier === 1) {
          retData.push({
            value: parentId,
            label: '本级'
          })
        }
        data.forEach((d) => {
          retData.push(d)
        })
        if (tier === 0) {
          curNode = retData
        } else {
          item.children = retData
        }
        item.loading = false
        if (callback) {
          callback()
        }
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
        item.loading = false
        if (callback) {
          callback()
        }
      })
    },
    citySelected (val) {
      if (val instanceof Array) {
        this.companyModel.PrjCityId = val[val.length - 1]
      } else {
        this.companyModel.PrjCityId = val
      }
    },
    changeCompensationDate (date) {
      this.companyModel.CompensationDate = this.$moment(date).format('YYYY-MM-DD')
    },
    changeAgreedPayDate (date) {
      this.companyModel.AgreedPayDate = this.$moment(date).format('YYYY-MM-DD')
    },
    clearGuarantee () {
      this.companyModel.ProjectId = null
      this.companyModel.ProjectName = null
      this.companyModel.GuaranteeId = null
    },
    selectGuarantee (project) {
      try {
        if (project.tag) {
          let item = this.guarantees.find(o => o.id === project.tag)
          this.companyModel.GuaranteeId = item.id
          this.companyModel.ProjectId = item.prjId
          this.companyModel.ProjectName = project.value
        } else {
          this.clearGuarantee()
        }
      } catch (e) {
        console.log(e)
        this.clearGuarantee()
      }
    },
    searchGuarantees (query) {
      this.$Api.Guarantee.listGuarantees({
        prjName: query,
        statusList: [1]
      }, 1, 1000).then((prjs) => {
        this.guarantees = prjs.data
      }).catch(err => {
        this.$Message.error('获取项目列表失败!' + err.message)
      })
    },
    clearProject () {
      this.companyModel.ProjectId = null
      this.companyModel.ProjectName = null
    },
    selectProject (project) {
      try {
        if (project.tag) {
          this.companyModel.ProjectId = project.tag
          this.companyModel.ProjectName = project.value
        } else {
          this.clearProject()
        }
      } catch (e) {
        console.log(e)
        this.clearProject()
      }
    },
    searchProjects (query) {
      this.$Api.Project.searchProjects({
        name: query
      }, 1, 1000).then((prjs) => {
        this.projects = prjs.data
      }).catch(err => {
        this.$Message.error('获取项目列表失败!' + err.message)
      })
    },
    clearCompany () {
      this.companyModel.GuaranteedCompanyId = null
      this.companyModel.GuaranteedName = null
      this.companyModel.GuaranteedBusinessLicense = null
    },
    selectCompany (company) {
      // console.log(company, typeof(company.value))
      try {
        if (company.tag) {
          this.companyModel.GuaranteedCompanyId = company.tag
          this.companyModel.GuaranteedName = company.value
          let companyItem = this.companies.find(o => o.tid === company.tag)
          this.companyModel.GuaranteedBusinessLicense = companyItem.businessLicense
        } else {
          this.clearCompany()
        }
      } catch (e) {
        console.log(e)
        this.clearCompany()
      }
    },
    searchCompany (query) {
      this.loading = true
      this.$Api.Company.listCompanies({
        isLocal: null,
        name: query,
        type: null
      }, 1, -1).then((companies) => {
        this.companies = companies.data
        this.loading = false
      }).catch(err => {
        this.$Message.error('获取列表失败!' + err.message)
        this.loading = false
      })
    },
    async submit () {
      console.log(this.companyModel, 'SUBMIT')
      this.$refs.newForm.validate(async (valid) => {
        console.log(this.companyModel, valid)
        if (valid) {
          this.loading = true
          this.$Spin.show()
          let model = Object.assign({}, this.companyModel)
          model.AgreedPayDate = this.$moment(model.AgreedPayDate).format('YYYY-MM-DD')
          model.CompensationDate = this.$moment(model.CompensationDate).format('YYYY-MM-DD')
          model.CompensationAmount *= 100
          model.GuaAmount *= 100
          model.AgreedPayAmount *= 100
          await this.$Api.Guarantee.addGuaranteedBadRecord(model)
            .then((payload) => {
              console.log('suc', payload)
              this.$Message.success('新增成功!')
              this.companyModel= {
                GuaranteedName: null,
                GuaranteedBusinessLicense: null,
                ProjectName: null,
                PrjManagerName: null,
                PrjManagerConstructorNo: null,
                PrjCityId: null,
                GuaType: null,
                GuaAmount: null,
                CompensationDate: new Date(),
                CompensationAmount: null,
                AgreedPayDate: null,
                AgreedPayAmount: 0,
                IsPaidOff: false
              }
              this.loading = false
              this.$Spin.hide()
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
        }
      })
    }
  }
}
</script>

<style lang="less">
</style>
